import React from "react";
import ReactDOM from "react-dom/client";

// Only the two weights the theme asks for. Pulling the whole family would ship a dozen unused font
// files, and Poppins is the display face for headings only: body copy stays on the system stack,
// which costs nothing to load.
import "@fontsource/poppins/600.css";
import "@fontsource/poppins/700.css";

import "./index.css";
import App from "./App";

const container = document.getElementById("root");

const tree = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// scripts/prerender.js writes real markup into #root at build time. Attaching with
// createRoot would throw that away and re-render from scratch, so hydrate instead when
// it is there and fall back to a normal client render in dev.
if (container.hasChildNodes()) {
  ReactDOM.hydrateRoot(container, tree);
} else {
  ReactDOM.createRoot(container).render(tree);
}
